import { ColumnsType } from 'antd/lib/table';
import { BonusTabs, CouponType, ShipmentStatus, FulfillmentStatus } from '@/components/ReferralHalloween/index.d';
import { formatLocalTime } from '@/utils/timeConversionTool';

export const useColumns = (type: BonusTabs, t: any, timezoneList: any) => {
    const fulfillmentStatusMap: Record<FulfillmentStatus, string> = {
        [FulfillmentStatus.fulfilled]: t('mybonus.fulfilled'), // 已发货
        [FulfillmentStatus.partial]: t('mybonus.partial'), // 未发货取消订单
        [FulfillmentStatus.restocked]: t('mybonus.restocked'), // 发货后退款
    };

    const shipmentStatusMap: Record<ShipmentStatus, string> = {
        [ShipmentStatus.tracking_added]: t('mybonus.tracking_added'), // 运输商已经收到了下单信息，并准备取包裹。
        [ShipmentStatus.confirmed]: t('mybonus.confirmed'), // 运输商已经收到了下单信息，并准备取包裹。
        [ShipmentStatus.ready_for_pickup]: t('mybonus.ready_for_pickup'), // 您的包裹已到达当地快递点，等待您去取件。
        [ShipmentStatus.failure]: t('mybonus.failure'), // 可能异常
        [ShipmentStatus.in_transit]: t('mybonus.in_transit'), // 您的包裹正在运输途中。
        [ShipmentStatus.delayed]: t('mybonus.delayed'), // 运输过久
        [ShipmentStatus.out_for_delivery]: t('mybonus.out_for_delivery'), // 您的订单正在给您派送的路上。
        [ShipmentStatus.attempted_delivery]: t('mybonus.attempted_delivery'), // 您的订单正在给您派送的路上。
        [ShipmentStatus.undelivered]: t('mybonus.undelivered'), // 您的包裹尝试派送但未能成功交付
        [ShipmentStatus.delivered]: t('mybonus.delivered'), // 您的包裹已经成功签收。
    };

    const data = {
        referral: [
            {
                title: t('mybonus.email'),
                dataIndex: 'email',
                key: 'email',
                width: 204,
            },
            {
                title: t('mybonus.date'),
                dataIndex: 'createTime',
                key: 'createTime',
                width: 194,
                render: (val) => (val ? formatLocalTime(val, timezoneList) : '--'),
            },
            {
                title: t('mybonus.action'),
                dataIndex: 'awardType',
                key: 'awardType',
                width: 135,
                render: (_val) => t('registered'),
            },
            {
                title: t('mybonus.rewards'),
                dataIndex: 'prizeName',
                width: 200,
                key: 'prizeName',
            },
        ] as ColumnsType<any>,
        cashback: [
            {
                title: t('mybonus.email'),
                dataIndex: 'email',
                key: 'email',
                width: 158,
            },
            {
                title: t('mybonus.date'),
                dataIndex: 'createTime',
                key: 'createTime',
                width: 204,
                render: (val) => (val ? formatLocalTime(val, timezoneList) : '--'),
            },
            {
                title: t('mybonus.orderstatus'),
                dataIndex: 'fulfillmentStatus',
                key: 'fulfillmentStatus',
                width: 145,
                render: (val: FulfillmentStatus) => {
                    return fulfillmentStatusMap[val] || t('unfulfilled'); // 默认未发货
                },
            },
            {
                title: t('mybonus.deliverystatus'),
                dataIndex: 'shipmentStatus',
                key: 'shipmentStatus',
                width: 180,
                render: (val: ShipmentStatus) => {
                    return shipmentStatusMap[val] || '--';
                },
            },
            {
                title: t('mybonus.type'),
                dataIndex: 'prizeType',
                key: 'prizeType',
                width: 180,
                render: (val) => {
                    if (val === CouponType.COUPONS) return t('discount');
                    if (val === CouponType.INTEGRAL) return t('ecocredits');
                    if (val === CouponType.CASH) return t('cash');
                    return t('gift_card');
                },
            },
            {
                title: t('mybonus.earnedamount'),
                dataIndex: 'prizeName',
                key: 'prizeName',
                width: 180,
            },
            {
                title: t('mybonus.bonusstatus'),
                dataIndex: 'awardStatus',
                key: 'awardStatus',
                width: 180,
                render: (_val) => t('mybonus.received'),
            },
        ] as ColumnsType<any>,
        leaderboard: [
            {
                title: t('mybonus.date'),
                dataIndex: 'awardIssueTime',
                key: 'awardIssueTime',
                render: (val) => (val ? formatLocalTime(val, timezoneList) : '--'),
                width: 158,
            },
            {
                title: t('mybonus.event'),
                dataIndex: 'awardStatus',
                key: 'awardStatus',
                width: 158,
                render: (_val, row) => {
                    if (row.ranking <= 3) {
                        return `${t('mybonus.top')} ${row.statDate}`;
                    }
                    return '--';
                },
            },
            {
                title: t('mybonus.rewards'),
                dataIndex: 'prizeName',
                key: 'prizeName',
                width: 158,
                render: (val) => val || '--',
            },
            {
                title: t('mybonus.ranking'),
                dataIndex: 'ranking',
                key: 'ranking',
                width: 158,
            },
        ] as ColumnsType<any>,
    };
    return data[type];
};
